<div class="location-card">
    <div class="location-image-container link" (click)="viewLocationDetails()">
        <img [src]="location.photo || 'https://www.memorialcare.org/sites/default/files/2025-12/mobile-location-location-default-v1.jpg'" alt="location photo">
    </div>
    <div class="location-info-container">
        <div class="name link" (click)="viewLocationDetails()">{{location.locationName}}</div>
        <div class="bottom-container">
            <div class="left-container">
                <div class="svg-and-label address">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 12 20" fill="none">
                        <ellipse cx="5.98285" cy="5.49797" rx="5.98285" ry="5.49797" fill="#959595"/>
                        <line x1="5.88548" y1="8.79688" x2="5.88548" y2="19.7928" stroke="#959595" stroke-width="2.19919"/>
                    </svg>
                    <div>
                        <div *ngIf="location.address1">{{location.address1}}</div>
                        <div *ngIf="location.city && location.zip">{{location.city}}, CA {{location.zip}}</div>
                    </div>
                </div>
                <div *ngIf="location.phone" class="svg-and-label phone-number">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path d="M14.8347 18.1434C11.354 18.1391 8.01707 16.7996 5.55581 14.4188C3.09455 12.0379 1.70983 8.8101 1.70532 5.44311C1.70532 4.43698 2.11851 3.47207 2.85398 2.76063C3.58945 2.04919 4.58697 1.64951 5.62708 1.64951C5.84733 1.64789 6.06721 1.66722 6.28355 1.70724C6.49269 1.73717 6.69829 1.78689 6.89739 1.85568C7.03742 1.90321 7.1622 1.98527 7.2594 2.09375C7.35659 2.20223 7.42282 2.33337 7.45155 2.4742L8.61956 7.42238C8.65104 7.55669 8.64725 7.69649 8.60853 7.82902C8.56981 7.96155 8.4974 8.08259 8.39789 8.1811C8.28706 8.29655 8.27853 8.3048 7.22989 8.83261C8.06965 10.6147 9.54305 12.0457 11.3818 12.8654C11.936 11.8427 11.9445 11.8345 12.0639 11.7273C12.1657 11.631 12.2908 11.561 12.4279 11.5235C12.5649 11.4861 12.7094 11.4824 12.8482 11.5129L17.9636 12.6427C18.1045 12.6743 18.2348 12.7401 18.3422 12.8339C18.4496 12.9277 18.5305 13.0464 18.5774 13.1788C18.6494 13.3745 18.7036 13.5759 18.7394 13.7808C18.7737 13.988 18.7908 14.1976 18.7906 14.4075C18.7748 15.4094 18.35 16.3645 17.6089 17.0644C16.8677 17.7644 15.8704 18.1522 14.8347 18.1434Z" fill="#888888"/>
                    </svg>
                    <div>{{location.phone}}</div>
                </div>
                <div class="direction-distance-wrapper">
                    <div *ngIf="location.locationDirection !== null && location.locationDirection !== ''" class="svg-and-label cursor-pointer direction">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <path d="M6.0392 2.68408L2.01318 4.69709V13.4201L6.0392 11.4071M6.0392 2.68408V11.4071M6.0392 2.68408L10.0652 4.69709M6.0392 11.4071L10.0652 13.4201M10.0652 13.4201L14.0912 12.0781V3.35508L10.0652 4.69709M10.0652 13.4201V4.69709" stroke="#959595" stroke-width="1.342" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div (click)="onGetDirections()">{{getDirectionsLabel}}</div>
                    </div>
                    <div class="location-distance-container">
                        <div class="svg-and-label distance">
                            <svg *ngIf="location.distanceInMiles !== null" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M17.5215 0L10.3549 17.7547L7.90029 9.92745L-7.59198e-05 7.71923L17.5215 0Z" fill="#959595"/>
                            </svg>
                            <div *ngIf="location.distanceInMiles !== null">{{location.distanceInMiles}} {{milesAwayText}}</div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="right-container">
                <div *ngIf="isIPUC === true">
                    <div *ngIf="location.nextAvailability !== null" class="as-soon-as">
                        <div>
                            {{asSoonAsText}} 
                        </div>
                        <div>
                            {{nextAvailabilityFormatted}}
                        </div>
                    </div>
                    <div *ngIf="location.nextAvailability == null && location.waitTime === null" class="wait-time">{{waitTime}}</div>
                    <div *ngIf="location.nextAvailability == null && location.waitTime !== null" class="wait-time">
                        <div>
                            {{walkInWait}} 
                        </div>
                        <div>  
                            {{waitTime}}
                        </div>
                    </div>
                </div>
                <!-- Action Button -->
                <button class="action-btn" (click)="handleAction($event)">
                    {{ getActionButtonText() }}
                </button>
            </div>
        </div>
    </div>    
</div>